import { createAsyncThunk } from "@reduxjs/toolkit";
import { loginUser, signupUser, verifyToken } from "../../pages/api-call/authAPI";

export const signup = createAsyncThunk(
    "auth/signupUser",
    async (formData, { rejectWithValue }) => {
        try {
            const data = await signupUser(formData);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const login = createAsyncThunk(
    "auth/loginUser",
    async (formData, { rejectWithValue }) => {
        try {
            const data = await loginUser(formData);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const verify = createAsyncThunk(
    "auth/verifyUserToken",
    async (formData, {rejectWithValue})=>{
        try{
            const data = await verifyToken(formData.user, formData.token)
            return data;
        }catch(error){
            return rejectWithValue(error.response.data.message);
        }
    }
)